import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class DateSelectorService {
  currentSelectedOption: Observable<Date>;

  private selectionState = new BehaviorSubject<Date>(new Date());

  constructor() {
    this.currentSelectedOption = this.selectionState.asObservable();
  }

  changeOption(option: Date) {
    this.selectionState.next(option);
  }
}
